import React from 'react';
import { TestimonialCard } from './TestimonialCard';
export function MastersSection() {
  return <div id="masters" className="grain-section w-full bg-page-bg px-6 py-20 md:py-28" data-id="element-196" data-mp="etv3sjy5vnzq">
      <div className="max-w-6xl mx-auto space-y-16 md:space-y-20" data-id="element-197" data-mp="ssuv5zd26gzl">
        {/* Chapter Indicator */}
        <div className="flex flex-col md:flex-row md:items-center gap-8 mb-8" data-id="element-198" data-mp="nu9rtr2ifh6x">
          <div className="text-8xl md:text-9xl font-black text-black/5 font-sans tracking-tighter" data-id="element-199" data-mp="nwcrl2tgsoou">
            03
          </div>
          <div className="h-px w-24 bg-black/10 hidden md:block" data-id="element-200" data-mp="xspi5rtpqmfd"></div>
          <div data-id="element-201" data-mp="1bjkx9lut1zre">
            <p className="text-xs text-teal-600 font-bold tracking-widest uppercase mb-3" data-id="element-202" data-mp="1bjch9l3dyebz">
              Chapter Three
            </p>
            <h2 className="text-4xl md:text-6xl font-bold text-ink tracking-tight" data-id="element-203" data-mp="17jaef8lwzev4">
              Who Are The Masters?
            </h2>
          </div>
        </div>

        <div className="text-xl text-ink-light max-w-3xl font-light leading-relaxed" data-id="element-204" data-mp="1gj7b9xigjk19">
          <p data-id="element-205" data-mp="z8p69681ytn">
            Let me introduce you to the two people who'll be building these
            transformation programs. Both are founders of the Peptide Science
            Institute. Both have track records of doing what most people in
            medicine still call "impossible."
          </p>
        </div>

        {/* Dr. Ali Mazloum */}
        <div className="bg-white rounded-[2.5rem] p-10 md:p-16 shadow-md border border-black/5" data-id="element-206" data-mp="f0l20bq35kbb">
          <div className="grid md:grid-cols-[1fr_2fr] gap-12 items-start" data-id="element-207" data-mp="jxbdelqy3rqe">
            <div className="space-y-6" data-id="element-208" data-mp="owfo5gtipxiu">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r3ytD56TFByCqkHoB8LFzP/DrAli1.png" alt="Dr. Ali Mazloum" width={560} height={560} loading="lazy" decoding="async" className="w-full max-w-[280px] h-auto rounded-3xl bg-gray-100" data-id="element-209" data-mp="ovcw35kglp1c" />
              <div data-id="element-210" data-mp="12pdozioqchts">
                <h3 className="text-3xl font-bold text-ink tracking-tight" data-id="element-211" data-mp="12px7b0ial88c">
                  Dr. Ali Mazloum
                </h3>
                <p className="text-teal-600 font-semibold tracking-wide uppercase mt-2 text-sm" data-id="element-212" data-mp="17lmcpkgztjck">
                  The Human MRI
                </p>
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-ink-light font-light leading-relaxed" data-id="element-213" data-mp="2zr34jjrgtiod">
              <p data-id="element-214" data-mp="3dhy60azmwxhx">
                Ali's the guy other doctors call when they're completely
                stumped. He works in one of the largest hospitals in Russia...
                And physicians routinely bring him "impossible cases"... Because
                he has this almost supernatural ability to see what everyone
                else has missed.
              </p>
              <p data-id="element-215" data-mp="8trmkigyfl3">
                He's reversed conditions that conventional medicine insists are
                incurable: Type 1 and type 2 diabetes... Rheumatoid arthritis...
                Cerebral vasculitis... Asthma, eczema, COPD, Graves' disease...
                He's restored kidney function in patients facing dialysis.
              </p>
              <div className="pl-8 border-l-4 border-teal-400 text-ink italic" data-id="element-216" data-mp="ckco7m0ph08q">
                <p data-id="element-217" data-mp="cmp0bijs8gdv">
                  Elite entrepreneurs, CEOs, athletes, and physicians themselves
                  come to him when nobody else can figure out what's wrong. And
                  they often experience recoveries modern medicine still insists
                  are impossible.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12" data-id="element-218" data-mp="3pyh8btuqnpzk">
            <TestimonialCard text="Hell-o Dr. Ali… I'm currently finishing up a program I started with Brenden... I'm 71… I lift 50 to 80 pound boxes full of food and drinks everyday. I plan on working until I can't. I swim 5 days a week and go to the gym 3 days a week. My performance has increased greatly since Brenden put me on his program… Thank you for all you guys and girls do for everyone!" name="Kenneth F., Meeting With the Master Client" data-id="element-219" data-mp="3q1llvhu3fy2w" />
          </div>
        </div>

        {/* Brenden Henry */}
        <div className="bg-white rounded-[2.5rem] p-10 md:p-16 shadow-md border border-black/5" data-id="element-220" data-mp="ui52bkknwz00">
          <div className="grid md:grid-cols-[1fr_2fr] gap-12 items-start" data-id="element-221" data-mp="pj28kwa4uf7c">
            <div className="space-y-6" data-id="element-222" data-mp="pgzadoyttfrj">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vptGHfonavjt96KY7KsnCE/Image_2.jpg" alt="Brenden Henry" width={560} height={560} loading="lazy" decoding="async" className="w-full max-w-[280px] h-auto rounded-3xl bg-gray-100" data-id="element-223" data-mp="kjfvqny7v0z2" />
              <div data-id="element-224" data-mp="bklu2j613ken">
                <h3 className="text-3xl font-bold text-ink tracking-tight" data-id="element-225" data-mp="bl3vdu7jsotf">
                  Brenden Henry
                </h3>
                <p className="text-teal-600 font-semibold tracking-wide uppercase mt-2 text-sm" data-id="element-226" data-mp="1sy46mp4ebfa">
                  World's #1 Peptide Authority
                </p>
              </div>
            </div>

            <div className="space-y-6 text-lg md:text-xl text-ink-light font-light leading-relaxed" data-id="element-227" data-mp="3o0xso0cgankp">
              <p data-id="element-228" data-mp="3jyugf9hyjeyd">
                After designing life-saving ventilator systems still used in
                hospitals today... Brenden turned his engineering mind to human
                biology. With an emphasis on anti-aging and longevity... He's
                gone deeper into peptide science than almost anyone else alive.
              </p>
              <p data-id="element-229" data-mp="28fne0e85ps80">
                He's thoroughly studied every major researcher and theory of
                aging. And used that knowledge to author Peptide Salvation and
                create Peptide Mastery... Both containing thousands of
                scientific citations.
              </p>
              <div className="pl-8 border-l-4 border-teal-400 text-ink italic" data-id="element-230" data-mp="1kq2t3psg0kw3">
                <p data-id="element-231" data-mp="1ppxn427ilqld">
                  His work has resulted in transformations modern medicine still
                  calls impossible: Reversing autoimmune diseases...
                  Regenerating organs... Reversing biological markers of
                  aging... And helping clients recover from type 1 and type 2
                  diabetes, kidney failure, traumatic brain injury, stroke,
                  Alzheimer's disease, severe drug withdrawal, and heart
                  failure.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12" data-id="element-232" data-mp="13pqan3aoz3bd">
            <TestimonialCard text="I f**king love you man. I am now officially completely cured and honestly I'm just excited to see how much further we can take things!!" name="Michal J., Transformation Services Client" data-id="element-233" data-mp="13pzzuonwx6g0" />
          </div>
        </div>
      </div>
    </div>;
}